import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-features-one',
    templateUrl: './features-one.component.html',
    styleUrls: ['./features-one.component.scss'],
    standalone: false
})
export class FeaturesOneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
